import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Confirm_button } from '../../environments/environment';
import { errMsgForExceedLimit, updateInfoType, CheckAuthOtpErrMsg, CheckCompanionCodeErrMsg, OAuthPlatformType, APIType, upsControlType,
  CheckCompanyMemberMsg, ChangeMemberMsgStr, AuthOtpType } from '../shareModel';
import { TranslateService } from '@ngx-translate/core';
import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { HomeComponent } from '../../app/dashboard/home/home.component';
import { GridviewComponent } from '../../app/dashboard/gridview/gridview.component';
import { isODM } from '../../environments/environment';
import { AddDeviceWifiComponent } from '../../app/device/add-device-wifi/add-device-wifi.component';
import { Router } from '@angular/router';
import { planChargeInfo } from '../shareModel';
import * as fromFeature from '../my-features';
import { Store } from '@ngrx/store';
import * as fromStore from '../store';
import { ActivateTrialLicenseParams } from '../my-features/activate-trial-license/activate-trial-license.model';
import { UpdateInfoModel } from '../my-features/updateInfo/update-info.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { AccountService } from '../services/account.service';
import { CompanionService } from '../services/companion.service';
import { ApiKeyService } from '../services/api-key.service';

import { AccountOauthParam } from '../my-features/account/oauth.model';
import { CountdownComponent } from 'ngx-countdown';
import { PlanSettingParams } from '../my-features/plan/plan-setting.model';

@Component({
  standalone: false,
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  @ViewChild('countdownUpsControl', { static: false }) countdownUpsControl: CountdownComponent;
  @ViewChild('countdownAPI', { static: false }) counterAPI: CountdownComponent;
  @ViewChild('countdownCompanion', { static: false }) counter: CountdownComponent;
  @ViewChild('countdownMobileSMS', { static: false }) counterMobileSMS: CountdownComponent;
  @ViewChild('counterGateway', { static: false }) counterGateway: CountdownComponent;
  @Output() connectEvt = new EventEmitter<string>();
  @Output() connectEvtAddOtp = new EventEmitter<string>();
  groupContentStr = errMsgForExceedLimit.GroupLimit['0'];
  floorMapContentStr = errMsgForExceedLimit.FloorMapLimit['0'];
  alertMailContentStr = errMsgForExceedLimit.EmailLimit['0'];
  globalMapContentStr = errMsgForExceedLimit.GlobalMapLimit['0'];
  UpdateInfoParam = {} as UpdateInfoModel;
  constructor(private translateService: TranslateService, private ngxService: NgxUiLoaderService, private router: Router,
    private store: Store<fromStore.State>, private messageService: MessageService, private accountService: AccountService,
    private companionService: CompanionService, private apiKeyService: ApiKeyService) { }
  Confirm_button = Confirm_button;
  powerMaster = isODM;
  dialogType = {
    groupLimit: false,
    mapLimit: false,
    mailLimit: false,
    RCC_ResultSuccess: false,
    RCC_ResultExist: false,
    RCC_ResultNotExist: false,
    RCC_ResultDoubleCheck: false,
    RWCC_NoWifi: false,
    RWCC_Connected: false,
    RWCC_ConnectedFailed: false,
    RWCC_ResultSuccess: false,
    RWCC_ConnectedNoInternet: false,
    RWCC_WifiPwdError: false,
    globalMapLimit: false,
    activatePlanKey_Success: false,
    activatePlanKey_Failure: false,
    isExpired: false,
    isTrialLicense: false,
    BatResetAlert: false,
    FirmwareAlert: false,
    ShareDeviceAlert: false,
    ShareTrialDeviceAlert: false,
    ShareDeviceLimit: false,
    ShareGroupLimit: false,
    ShareUserNameLimit: false,
    filterMonthLimit: false,
    ShareExpiredDeviceAlert: false,
    AccountEmailAlertDialog: false,
    AccountMobileAlertDialog: false,
    TwoFactorAuthEnableAlert: false,
    TwoFactorAuthDisableAlert: false,
    TwoFactorAuthDialog: false,
    OTPLockDialog: false,
    SocialCombineEnableAlert: false,
    SocialCombineDisableAlert: false,
    SocialCombineOnlyOneAlert: false,
    SocialCombineAccountAlert: false,
    SocialCombineNoPasswordAlert: false,
    SocialCombineEmailDialog: false,
    RCC_AddDeviceType: false,
    PurchaseAlert: false,
    CompanionCodeDialogType: false,
    CompanionEnableAlert: false,
    CompanionDisableAlert: false,
    CompanionReceive: false,
    ConfirmCompanionEventDialog: false,
    CompanionCodeLockDialog: false,
    MobileVerificationDialog: false,
    MobileSMSCodeLockDialog: false,
    MobileSMSLockDialog: false,
    CheckDeleteAdminMemberDialog: false,
    MobileRemoveAlertDialog: false,
    CompanyMemberListDialog: false,
    ImportCompanyMemberDialog: false,
    confirmDeleteMember: false,
    apiAgreeAPITermsAlert: false,
    apiTwoFactorEnableAlert: false,
    apiCreateDialog: false,
    APITwoFactorAuthDialog: false,
    APICodeLockDialog: false,
    apiPlanSettingDowngradeAlert: false,
    isLocked: false,
    isAddToCloud: false,
    UpgradeGatewayDialog: false,
    UpgradeGatewayLockDialog: false,
    addToHierarchyWarning: false,
    agreeUpsControlAlert: false,
    upsControlTwoFactorEnableAlert: false,
    upsControlTwoFactorAuthDialog: false,
    upsControlCodeLockDialog: false,
    cloudControlDisabledDialog: false,
    cloudControlTurnOnDialog: false,
    cloudControlTurnOffDialog: false,
    cloudControlProcessingDialog: false,
    cloudControlResultSuccessDialog: false,
    cloudControlResultFailedDialog: false,
  };
  activateParams = {} as ActivateTrialLicenseParams;

  shareModel = {
    price: planChargeInfo
  };

  trialRemainingDays: number;
  OTPNumber: string;
  dialogSaveDirty = false;
  socialType: any;
  accountEmail: any;
  accountMobile: any;
  accountCountryCodes: any;
  systemNotificationEmail = 'cps';
  config = {
    leftTime: 300,
    template: '$!m!:$!s!',
  };
  // configMobile = {
  //   leftTime: 90,
  //   template: '$!m!:$!s!',
  // };
  OTPOvertime = false;
  errorMsg = '';
  errorMsgByLock = false;
  OTPNumberSubmitDisabled = true;
  PlatformEmail: string;
  PPCEmail: string;

  selectDefaultReceive = null;
  companionCodeAuthType: string;

  CompanionCode: string;
  CompanionCodedialogSaveDirty = false;
  CompanionCodeOvertime = false;
  CompanionCodeSubmitDisabled = true;
  closeCompanionConfirmOTP = false;
  errorMsgCompanionCode = '';
  companionerrorMsgByLock = false;

  // API
  APICodeAuthType: string;
  APICode: string;
  APICodedialogSaveDirty = false;
  APICodeOvertime = false;
  APICodeSubmitDisabled = true;
  closeAPIConfirmOTP = false;
  errorMsgAPICode = '';
  APIerrorMsgByLock = false;

  // UPS Control
  upsControlCodeAuthType: string;
  upsControlCode: string;
  upsControlCodedialogSaveDirty = false;
  upsControlCodeOvertime = false;
  upsControlCodeSubmitDisabled = true;
  closeUpsControlConfirmOTP = false;
  errorMsgupsControlCode = '';
  upsControlerrorMsgByLock = false;

  // Upgrade Gateway
  UpgradeGatewayType: string;
  UpgradeGatewayCode: string;
  UpgradeGatewaydialogSaveDirty = false;
  UpgradeGatewayOvertime = false;
  UpgradeGatewaySubmitDisabled = true;
  closeUpgradeGatewayConfirmOTP = false;
  errorMsgUpgradeGatewayCode = '';
  UpgradeGatewayErrorMsgByLock = false;

  MobileSMSCode: string;
  MobileSMSCodedialogSaveDirty = false;
  MobileSMSCodeOvertime = false;
  MobileSMSCodeSubmitDisabled = true;
  errorMsgMobileSMS = '';
  mobileErrorMsgByLock = false;
  selectDefaultReceiveSMS = true;

  mobileConfirmFlag = false;
  companyMemberList = [];
  CompanyName = '';
  selectCompanyName = '';
  RegionId = -1;
  ParentRegionId = -1;
  DeleteItemIndex = -1;
  addMemberErrorMsgFlag = false;
  addMemberErrorMsg = '';
  memberEmailInput = '';
  addCompanyMemberFlag = false;
  fileUploaded: File;
  importMemberFlie = '';
  importMemberErrorMsg = false;
  checkDeleteAdminMemberName = '';
  checkDeleteAdminMemberCompany = '';
  apikey: string;
  canAdd: boolean;
  addToCloudTab: number;
  addDeviceToPlanParam: PlanSettingParams;
  powerActionOptions = '';
  ngOnInit() {
  }

  handleEvent(e) {
    if (e.left <= 0) {
      this.errorMsg = CheckAuthOtpErrMsg[2];
      this.OTPOvertime = true;
    }
  }

  handleEventCompanionCode(authType, e) {
    if (e.left <= 0) {
      this.errorMsgCompanionCode = CheckCompanionCodeErrMsg[2];
      this.CompanionCodeOvertime = true;
    }
  }

  handleMobileSMS(e) {
    if (e.left <= 0) {
      this.errorMsgMobileSMS = CheckAuthOtpErrMsg[2];
      this.MobileSMSCodeOvertime = true;
    }
  }

  handleAPICode(authType, e) {
    if (e.left <= 0) {
      this.errorMsgAPICode = CheckAuthOtpErrMsg[2];
      this.APICodeOvertime = true;
    }
  }

  handleUpsControlCode(authType, e) {
    if (e.left <= 0) {
      this.errorMsgupsControlCode = CheckAuthOtpErrMsg[2];
      this.upsControlCodeOvertime = true;
    }
  }


  closeDialog() {
    Object.keys(this.dialogType).forEach(item => {
      this.dialogType[item] = false;
    });
  }

  connectChange(result: string) {
    // For Preference
    if (
      result === 'confrimOTPnumber') {
      this.accountService.SetAuthOtp = this.OTPNumber;
    } else if (result === 'updateAccountMobileConfirm') {
      this.accountService.SetAuthOtp = this.MobileSMSCode;
    } else if (
      result === 'confrimCompanionCode' ||
      result === 'enableCompanion' ||
      result === 'disableCompanion' ||
      result === 'Confirm_CompanionEvent' ||
      result === 'ResendCode') {
      this.companionService.SetCompanionCode = this.CompanionCode;
    } else if (
      result === APIType.enableAPIAccess ||
      result === APIType.disableAPIAccess ||
      result === APIType.enableAPIKey ||
      result === APIType.disableAPIKey ||
      result === APIType.addAPIKey ||
      result === APIType.deleteAPIKey) {
      this.apiKeyService.SetApiCode = this.APICode;
    } else if (
      result === upsControlType.enableUpsControlAccess ||
      result === upsControlType.disableUpsControlAccess ||
      result === upsControlType.closeUpsControlOTPdailog ||
      result === upsControlType.turnOn ||
      result === upsControlType.turnOff ||
      result === upsControlType.powerCycle
    ) {
      this.accountService.SetAuthOtp = this.upsControlCode;
    }
    this.connectEvt.emit(result);
  }

  connectAddOtpChange(result: string) {
    if (
      result === upsControlType.turnOn ||
      result === upsControlType.turnOff ||
      result === upsControlType.powerCycle) {
      this.accountService.SetAuthOtp = this.upsControlCode;
    }
    this.connectEvtAddOtp.emit(result);
  }
  

  OTPkeyupEnter(e) {
    if (this.OTPNumber !== undefined && this.OTPNumber.length >= 6) {
      this.connectChange('confrimOTPnumber');
    }
  }

  CompanionCodekeyupEnter(e) {
    if (this.CompanionCode !== undefined && this.CompanionCode.length >= 6) {
      if (this.companionCodeAuthType === 'enableCompanionConfirm') {
        this.connectChange('enableCompanion');
      } else if (this.companionCodeAuthType === 'disableCompanionConfirm') {
        this.connectChange('disableCompanion');
      } else if (this.companionCodeAuthType === 'ResendCode') {
        this.connectChange('ResendCode');
      } else if (this.companionCodeAuthType === 'ConfirmCompanionEvent') {
        this.connectChange('Confirm_CompanionEvent');
      }
    }
  }

  MobileSMSCodekeyupEnter(e) {
    if (this.MobileSMSCode !== undefined && this.MobileSMSCode.length >= 6) {
      this.connectChange('confrimMobileSMSCode');
    }
  }

  APICodekeyupEnter(e) {
    if (this.APICode !== undefined && this.APICode.length >= 6) {
      if (this.APICodeAuthType === APIType.enableAPIAccess) {
        this.connectChange(APIType.enableAPIAccess);
      } else if (this.APICodeAuthType === APIType.disableAPIAccess) {
        this.connectChange(APIType.disableAPIAccess);
      } else if (this.APICodeAuthType === APIType.enableAPIKey) {
        this.connectChange(APIType.enableAPIKey);
      } else if (this.APICodeAuthType === APIType.disableAPIKey) {
        this.connectChange(APIType.disableAPIKey);
      } else if (this.APICodeAuthType === APIType.addAPIKey) {
        this.connectChange(APIType.addAPIKey);
      } else if (this.APICodeAuthType === APIType.deleteAPIKey) {
        this.connectChange(APIType.deleteAPIKey);
      }
    }
  }

  upsControlCodekeyupEnter(e) {
    if (this.upsControlCode !== undefined && this.upsControlCode.length >= 6) {
      if (this.upsControlCodeAuthType === upsControlType.enableUpsControlAccess) {
        this.connectChange(upsControlType.enableUpsControlAccess);
      } else if (this.upsControlCodeAuthType === upsControlType.disableUpsControlAccess) {
        this.connectChange(upsControlType.disableUpsControlAccess);
      }
    }
  }

  // 修改做法,不要讓Key存在Storage內
  UpgradeGatewayCodekeyupEnter(e) {
    if (this.UpgradeGatewayCode !== undefined && this.UpgradeGatewayCode.length >= 6) {
      if (this.UpgradeGatewayType === 'SoftwareUpgrade') {
        let paramStr = ''
        paramStr = paramStr + 'SoftwareUpgrade' + ',' + this.UpgradeGatewayCode
        
        this.connectEvt.emit(paramStr);
      }
    }
  }

  removeAccountMobileAlertDialog(companionReceipt) {
    if (companionReceipt !== undefined  && companionReceipt !== 0) {
      this.selectDefaultReceiveSMS = false;
    }
    this.dialogType.MobileRemoveAlertDialog = true;
  }

  redirect(url: string) {
    this.router.navigate([`${url}`]);
  }

  expiredDialog(item: any = null) {
    this.dialogType.isExpired = true;
  }

  isTrialDialog(item) {
    this.dialogType.isTrialLicense = true;
    this.activateParams = {
      ...this.activateParams,
      dcode: parseInt(item.dcode, 10),
    };
    this.trialRemainingDays = item.trialRemainDay;
  }

  checkLocked(info: any = null , canAdd : boolean = false) {
    this.dialogType.isLocked = true;
    this.canAdd = canAdd;
    this.addDeviceToPlanParam = info;
  }

  addDeviceToCloudRedirect(info: any = null ,addToCloudTab) {
    this.dialogType.isAddToCloud = true;
    this.addToCloudTab = addToCloudTab;
    this.addDeviceToPlanParam = info;
    this.addDeviceToPlan();
  }

  addDeviceToPlan() {
    if (this.addDeviceToPlanParam !== null) {
      this.dispatchUpdateInfoAction(updateInfoType.UpdatePlanSetting);
      this.store.dispatch(new fromFeature.GetUpdatePlanSettings({ ...this.addDeviceToPlanParam }));
    }
  };
  
  dashboardRouter() {
    this.router.navigate(['/dashboard']);
  }
  
  planSettingRouter() {
    this.router.navigate(['/plan-setting']);
  }

  isCriticalUpload() {
    this.dialogType.FirmwareAlert = true;
  }

  btyReplaceCheck() {
    this.dialogType.BatResetAlert = true;
  }

  enableFreeTrial() {
    // 啟用成功失敗在home.component判定
    this.ngxService.start();
    this.store.dispatch(new fromFeature.GetActivateTrialLicense({ ...this.activateParams }));
    this.dialogType.isTrialLicense = false;
  }

  purchaseRouter() {
    this.router.navigate(['/purchase']);
  }

  ReLoadUpdateState() {
    this.resetUpdateInfoState();
    this.ngxService.stop();
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  private dispatchUpdateInfoAction(type: string): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoAction({ ...this.UpdateInfoParam }));
  }

  updateFirmware() {
    this.router.navigate(['/device-setting']);
  }

  alertShareDevice() {
    this.dialogType.ShareDeviceAlert = true;
  }

  alertTrialShareDevice() {
    this.dialogType.ShareTrialDeviceAlert = true;
  }

  alertExpiredShareDevice() {
    this.dialogType.ShareExpiredDeviceAlert = true;
  }

  alertTwoFactorAuthEnable() {
    this.dialogType.MobileSMSCodeLockDialog = false;
    this.dialogType.MobileSMSLockDialog = false;
    this.dialogType.TwoFactorAuthEnableAlert = true;
  }

  alertTwoFactorAuthDisable() {
    this.dialogType.MobileSMSCodeLockDialog = false;
    this.dialogType.MobileSMSLockDialog = false;
    this.dialogType.TwoFactorAuthDisableAlert = true;
  }

  twoFactorAuthDialog() {
    this.dialogType.TwoFactorAuthDialog = true;
    this.OTPNumber = '';
    this.dialogSaveDirty = false;
    this.OTPOvertime = false;
    this.OTPNumberSubmitDisabled = true;
    this.dialogType.MobileVerificationDialog = false;
  }

  OTPNumberOnchange($event) {
    const OTPNumberLength = $event.replaceAll('_', '');
    if (OTPNumberLength.length >= 6) {
      this.OTPNumberSubmitDisabled = false;
    } else {
      this.OTPNumberSubmitDisabled = true;
    }
  }

  CompanionCodeOnchange($event) {
    const CompanionCodeLength = $event.replaceAll('_', '');
    if (CompanionCodeLength.length >= 6) {
      this.CompanionCodeSubmitDisabled = false;
    } else {
      this.CompanionCodeSubmitDisabled = true;
    }
  }

  MobileSMSCodeOnchange($event) {
    const MobileSMSLength = $event.replaceAll('_', '');
    if (MobileSMSLength.length >= 6) {
      this.MobileSMSCodeSubmitDisabled = false;
    } else {
      this.MobileSMSCodeSubmitDisabled = true;
    }
  }

  APICodeOnchange($event) {
    const APICodeLength = $event.replaceAll('_', '');
    if (APICodeLength.length >= 6) {
      this.APICodeSubmitDisabled = false;
    } else {
      this.APICodeSubmitDisabled = true;
    }
  }

  upsControlCodeOnchange($event) {
    const upsControlCodeLength = $event.replaceAll('_', '');
    if (upsControlCodeLength.length >= 6) {
      this.upsControlCodeSubmitDisabled = false;
    } else {
      this.upsControlCodeSubmitDisabled = true;
    }
  }
  

  UpgradeGatewayCodeOnchange($event) {
    const UpgradeGatewayCodeLength = $event.replaceAll('_', '');
    if (UpgradeGatewayCodeLength.length >= 6) {
      this.UpgradeGatewaySubmitDisabled = false;
    } else {
      this.UpgradeGatewaySubmitDisabled = true;
    }
  }


  alertAccountEmailAlertDialog(accountEmail) {
    this.accountEmail = accountEmail;
    this.dialogType.AccountEmailAlertDialog = true;
  }

  alertAccountMobileAlertDialog(accountMobile, accountCountryCodes) {
    this.accountMobile = accountMobile;
    this.accountCountryCodes = accountCountryCodes;
    this.dialogType.AccountMobileAlertDialog = true;
    this.mobileConfirmFlag = false;
  }

  alertOTPLock() {
    this.dialogType.OTPLockDialog = true;
  }

  alertSocialCombineEnable(socialType) {
    this.socialType = socialType;
    this.dialogType.SocialCombineEnableAlert = true;
  }

  alertSocialCombineDisable(socialType) {
    this.socialType = socialType;
    this.dialogType.SocialCombineDisableAlert = true;
  }

  alertSocialCombineOnlyOneAlert() {
    this.dialogType.SocialCombineOnlyOneAlert = true;
  }

  alertSocialCombineAccountAlert() {
    this.dialogType.SocialCombineAccountAlert = true;
  }

  alertSocialCombineNoPasswordAlert(socialType: string) {
    this.socialType = socialType;
    this.dialogType.SocialCombineNoPasswordAlert = true;
  }

  alertSocialCombineEmailDialog(param) {
    switch (param.socialType) {
      case OAuthPlatformType.Apple:
        this.socialType = 'apple';
        break;
      case OAuthPlatformType.Google:
        this.socialType = 'goole';
        break;
      // 2026/07/21 kyrie.hung 移除 Facebook 登入/綁定功能
      // case OAuthPlatformType.Facebook:
      //   this.socialType = 'facebook';
      //   break;
    }
    this.PPCEmail = param.AccountEmail;
    this.PlatformEmail = param.PlatformEmail;
    this.dialogType.SocialCombineEmailDialog = true;
  }

  chooseAccountEmail(res) {
    const param: AccountOauthParam = {
      Code: '',
      Email: '',
      UpdateType: updateInfoType.AddOAuth
    };
    if (res) {
      switch (this.systemNotificationEmail) {
        case 'cps':
          param.Email = this.PPCEmail;
          break;
        case 'social':
          param.Email = this.PlatformEmail;
          break;
      }
    } else {
      param.Email = this.PPCEmail;
    }
    this.store.dispatch(new fromFeature.UpdateAccountEmail(param));
  }

  alertPurchaseAlert() {
    this.dialogType.PurchaseAlert = true;
  }


  alertCompanionEnable() {
    this.dialogType.CompanionEnableAlert = true;
  }

  alertCompanionDisable() {
    this.dialogType.CompanionDisableAlert = true;
  }

  alertCompanionCodeLock() {
    this.dialogType.CompanionCodeLockDialog = true;
  }

  alertAPICodeLock() {
    this.dialogType.APICodeLockDialog = true;
    this.dialogType.OTPLockDialog = false;
  }

  alertUpgradeGatewayCodeLock() {
    this.dialogType.UpgradeGatewayLockDialog = true;
    this.dialogType.OTPLockDialog = false;
  }

  alertMobileSMSCodeLock() {
    this.dialogType.MobileSMSCodeLockDialog = true;
    this.dialogType.OTPLockDialog = false;
  }

  alertMobileSMSLock() {
    this.dialogType.MobileSMSLockDialog = true;
    this.dialogType.OTPLockDialog = false;
  }

  showCompanionCodeAuthDialog(reslut, companionReceiveType) {
    this.errorMsgCompanionCode = '';
    this.dialogType.CompanionCodeDialogType = true;
    this.CompanionCode = '';
    this.CompanionCodedialogSaveDirty = false;
    this.CompanionCodeOvertime = false;
    this.CompanionCodeSubmitDisabled = true;
    this.companionCodeAuthType = reslut;
    this.selectDefaultReceive = companionReceiveType;
    this.counter.restart();
  }

  showAPIAuthDialog(reslut) {
    this.errorMsgAPICode = '';
    this.dialogType.APITwoFactorAuthDialog = true;
    this.APICode = '';
    this.APICodedialogSaveDirty = false;
    this.APICodeOvertime = false;
    this.APICodeSubmitDisabled = true;
    this.APICodeAuthType = reslut;
    this.counterAPI.restart();
  }

  showUpsControlAuthDialog(reslut) {
    this.errorMsgupsControlCode = '';
    this.dialogType.upsControlTwoFactorAuthDialog = true;
    this.upsControlCode = '';
    this.upsControlCodedialogSaveDirty = false;
    this.upsControlCodeOvertime = false;
    this.upsControlCodeSubmitDisabled = true;
    this.upsControlCodeAuthType = reslut;
    this.countdownUpsControl.restart();
  }

  showMobileVerificationDialog() {
    this.dialogType.TwoFactorAuthDialog = false;
    this.dialogType.MobileVerificationDialog = true;
    this.MobileSMSCode = '';
    this.MobileSMSCodedialogSaveDirty = false;
    this.MobileSMSCodeOvertime = false;
    this.MobileSMSCodeSubmitDisabled = true;
    this.counterMobileSMS.restart();
  }

  showUpgradeGatewayVersionDialog(reslut) {
    this.errorMsgUpgradeGatewayCode = '';
    this.dialogType.UpgradeGatewayDialog = true;
    this.UpgradeGatewayCode = '';
    this.UpgradeGatewaydialogSaveDirty = false;
    this.UpgradeGatewayOvertime = false;
    this.UpgradeGatewaySubmitDisabled = true;
    this.UpgradeGatewayType = reslut;
    this.counterGateway.restart();
  }

  addCompanyMemberDialog(selectedRegionName, selectedRegionId, selectedParentRegionId) {
    this.selectCompanyName = selectedRegionName;
    this.CompanyName = selectedRegionName;
    this.RegionId = selectedRegionId;
    this.ParentRegionId = selectedParentRegionId;
    this.memberEmailInput = '';
    this.addMemberErrorMsgFlag = false;
    this.dialogType.CompanyMemberListDialog = true;
    this.addCompanyMemberFlag = false;
  }

  importCompanyMemberDialog() {
    this.dialogType.ImportCompanyMemberDialog = true;
    this.importMemberFlie = '';
    this.importMemberErrorMsg =  false;
  }

  // showDeleteMemberConfirmDialog(deleteItemIndex) {
  //   this.DeleteItemIndex = deleteItemIndex;
  //   this.dialogType.confirmDeleteMember = true;
  // }

  deleteMember(deleteItemIndex, rowdata) {
    this.DeleteItemIndex = deleteItemIndex;
    if (rowdata.acode !== undefined && rowdata.admins.includes(rowdata.acode)) {
      this.dialogType.CheckDeleteAdminMemberDialog = true;
      this.checkDeleteAdminMemberName = rowdata.account;
      this.checkDeleteAdminMemberCompany = rowdata.company;
    } else {
      this.companyMemberList.splice(this.DeleteItemIndex , 1);
    }
  }

  confirmDeleteMember() {
    this.companyMemberList.splice(this.DeleteItemIndex , 1);
  }

  closeCheckDeleteAdminMemberDialog() {
    this.dialogType.CheckDeleteAdminMemberDialog = false;
  }

  closeImportCompanyMemberDialog() {
    this.dialogType.ImportCompanyMemberDialog = false;
  }

  closeAddMemberErrorMsg() {
    this.addMemberErrorMsgFlag = false;
  }

  memberEmailOnchange() {
    this.addMemberErrorMsgFlag = false;
    this.addCompanyMemberFlag = false;
  }

  errorCompanyMember(e) {
    const type = parseInt(e.RespType)
    if (type !== 0) {
      this.memberEmailInput = e.Account;
      this.addMemberErrorMsgFlag = true;
      const changeAccountStr = ChangeMemberMsgStr.Account;
      const changeCompanyStr = ChangeMemberMsgStr.Company;
      const errorMsg = CheckCompanyMemberMsg[type];
      if (type == 1) {
        this.addMemberErrorMsg = errorMsg.replace(changeAccountStr, e.Account);
      } else if (type == 2 || type == 3) {
        if (this.CompanyName == "") {
          this.addMemberErrorMsg = CheckCompanyMemberMsg[8] // 若為其他集團或其他地區的公司,因取不出RegionName,故替換Wording,加入一個Type 8來替換
        } else {
          this.addMemberErrorMsg = errorMsg.replace(changeAccountStr, e.Account).replace(changeCompanyStr, this.CompanyName);
        }
      } else if (type == 4) {
        this.addMemberErrorMsg = errorMsg.replace(changeAccountStr, e.Account).replace(changeCompanyStr, e.SelectCompanyName);
      } else {
        this.addMemberErrorMsg = errorMsg;
      }
    } else {
      this.companyMemberList.push({ 'account': this.memberEmailInput, value: this.memberEmailInput });
      this.addCompanyMemberFlag = true;
      this.memberEmailInput = null;
    }
  }

  closeImportMemberErrorMsg() {
    this.importMemberErrorMsg = false;
  }

  handleFileInput(event) {
    this.fileUploaded = event.target.files[0];
    this.readExcel();
    this.importMemberErrorMsg = false;
  }

  readExcel() {
    // const readFile = new FileReader();
    // readFile.onload = (e) => {
    //   this.storeData = readFile.result;
    //   const data = new Uint8Array(this.storeData);
    //   const arr = [];
    //   for (let i = 0; i !== data.length; ++i) {
    //     arr[i] = String.fromCharCode(data[i]);
    //   }
    //   const binaryStr = arr.join('');
    //   const workbook = XLSX.read(binaryStr, { type: 'binary' });
    //   const first_sheet_name = workbook.SheetNames[0];
    //   this.worksheet = workbook.Sheets[first_sheet_name];
    // };
    // readFile.readAsArrayBuffer(this.fileUploaded);
  }

  alertAPITermsAgree() {
    this.dialogType.apiAgreeAPITermsAlert = true;
  }

  alertAPITwoFactorEnable() {
    this.dialogType.apiTwoFactorEnableAlert = true;
  }

  generateAPIKeyDialog(key) {
    this.dialogType.apiCreateDialog = true;
    this.apikey = key;
  }

  alertPlanSettingDowngrade() {
    this.dialogType.apiPlanSettingDowngradeAlert = true;
  }

  copyApiKeyText() {
    const inputElement = document.getElementById('InputApiId') as HTMLInputElement;
    const copy = inputElement.select();
    (navigator as any).clipboard.writeText(inputElement.value)
  }

  addToHierarchyWarning() {
    this.dialogType.addToHierarchyWarning = true;
  }

  alertUpsControlAgree() {
    this.dialogType.agreeUpsControlAlert = true;
  }

  alertUpsControlTwoFactorEnable() {
    this.dialogType.upsControlTwoFactorEnableAlert = true;
  }

  alertUpsControlCodeLock() {
    this.dialogType.upsControlCodeLockDialog = true;
    this.dialogType.OTPLockDialog = false;
  }

  cloudControlDisabled() {
    this.dialogType.cloudControlDisabledDialog = true;
  }

  cloudControlTurnOffDialog() {
    this.dialogType.cloudControlTurnOffDialog = true;
    this.powerActionOptions = '';
  }

  cloudControlTurnOnDialog() {
    this.dialogType.cloudControlTurnOnDialog = true;
  }

  showcloudControlProcessing() {
    this.dialogType.cloudControlProcessingDialog = true;
  }

  showcloudControlResult(item: any, type: number) {
    if (type == AuthOtpType.TurnOn) {
      this.upsControlCodeAuthType = 'TurnOn'
    } else if (type == AuthOtpType.TurnOff) {
      this.upsControlCodeAuthType = 'TurnOff'
    } else {
      this.upsControlCodeAuthType = 'PowerCycle'
    }
    this.dialogType.cloudControlProcessingDialog = false;
    if (item.ExecStatus == 1) { // Success
      this.dialogType.cloudControlResultSuccessDialog = true;
    } else if (item.ExecStatus == 0 || item.ExecStatus == 2) { // Fail
      this.dialogType.cloudControlResultFailedDialog = true;
    }
  }
}
